export default "__VITE_ASSET__CGWmWhfR__"